import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import LoadingOverlay from '../components/common/LoadingOverlay';

const Home = () => {
  const { user, isLoading } = useAuth();

  useEffect(() => {
    // If not loading and no user, redirect to login
    if (!isLoading && !user) {
      window.location.href = `${process.env.REACT_APP_API_BASE_URL}/api/auth/login`;
    }
  }, [isLoading, user]);

  if (isLoading) {
    return (
      <LoadingOverlay message="Loading..." />
    );
  }

  if (user) {
    // If authenticated, go to the consultation page
    return <Navigate to="/consultation" />;
  }

  // This will briefly show while the redirect happens
  return (
    <LoadingOverlay message="Redirecting to login..." />
  );
};

export default Home; 